import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share_poster_download",
  "use": "icon-share_poster_download-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-share_poster_download\"><g fill=\"#FFF\" fill-rule=\"nonzero\"><path d=\"M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0Zm0 30C8.2 30 2 23.8 2 16S8.2 2 16 2s14 6.2 14 14-6.2 14-14 14Z\" /><path d=\"m21.2 16.2-4 4V7h-2.4v13.2l-4-4L9 18l7 7 7-7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol